import { FiInfo } from 'react-icons/fi';
import { createIconComponent } from '../createIconComponent';

export const Information = createIconComponent(FiInfo);
